var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1267.06 136.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#efb23e;}.cls-4{fill:#002173;}.cls-5{fill:#fff;}.cls-6{fill:url(#pattern);}.cls-7{stroke:#000;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    "data-name": "pattern",
    width: 41,
    height: 43,
    patternTransform: "matrix(0.18, 0, 0, -0.19, 116.74, 836.93)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 41 43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 41,
    height: 43
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 41,
    height: 43,
    transform: "matrix(1, 0, 0, -1, 0, 43)",
    xlinkHref: "data:image/png;base64,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"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "supplier centerlogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9129",
    "data-name": "Group 9129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WHITELOGO2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-3",
    d: "M540.78,86.64",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-3",
    d: "M467.55,120.49q0-7.78,4-12.07a12.75,12.75,0,0,1,9.72-4.19,13.23,13.23,0,0,1,11.9,7.38,18.7,18.7,0,0,1,1.85,8.55,16.55,16.55,0,0,1-3.52,11.06,12.57,12.57,0,0,1-10.06,4.69,12.34,12.34,0,0,1-10.22-4.86A15.9,15.9,0,0,1,467.55,120.49Zm3.85,0a13.19,13.19,0,0,0,2.85,8.88,9.28,9.28,0,0,0,13.08.84c.33-.33.67-.5.83-.84A14.49,14.49,0,0,0,491,120a16.46,16.46,0,0,0-1.51-7,9.18,9.18,0,0,0-12.19-4.48,9.35,9.35,0,0,0-3.06,2.3c-1.84,2.18-2.68,5.53-2.85,9.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-3",
    d: "M506.76,135.57V104.74h3.86l15.08,24.13V104.74h3.69V135.4h-4l-15.09-24.13V135.4l-3.52.17Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-3",
    d: "M581.34,124.68l3.85,1a13.71,13.71,0,0,1-4.35,7.71,11.54,11.54,0,0,1-7.71,2.52,13.27,13.27,0,0,1-6.7-1.68,12.62,12.62,0,0,1-4.69-5.53,23.37,23.37,0,0,1-1.85-8.88,16.82,16.82,0,0,1,1.85-8.55,12.45,12.45,0,0,1,4.85-5.36,14.09,14.09,0,0,1,6.88-1.84,11.61,11.61,0,0,1,7.2,2.34,11.9,11.9,0,0,1,4.19,6.7l-3.69,1c-1.34-4.36-3.85-6.37-7.71-6.37a8.6,8.6,0,0,0-8.37,5.36,19.27,19.27,0,0,0-1.35,6.87c0,4.19.84,7.38,2.52,9.39a8.59,8.59,0,0,0,6.7,3.18,7.84,7.84,0,0,0,5.36-2A9.06,9.06,0,0,0,581.34,124.68Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-3",
    d: "M593.74,135.57l11.06-30.66h4l11.73,30.66h-4.36l-3.35-9.21H600.78l-3.19,9.21ZM602,122.84h9.72l-3-8.55c-.83-2.68-1.67-4.69-2-6.37a33.93,33.93,0,0,1-1.5,5.87Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-3",
    d: "M630.44,135.57V104.74h3.85v27.15h14.08v3.68Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-3",
    d: "M655.74,135.57V104.74h3.86v27.15h14.07v3.68Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-4",
    d: "M182.83,85.63V36.36c2.35,0,10.39-.16,17.09-.16a23.69,23.69,0,0,1,22.8,24.3c0,16.75-11.74,25.13-24.8,25.13Zm18.43-1.84c6-.67,14.42-4.69,14.42-22.79,0-15.25-5.7-22-15.42-22.79-1.68-.17-7-.17-8.71-.17h-2.68V84h1.84c1.34,0,6.53.16,10.56-.17Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-4",
    d: "M576.14,85.3V36c2.35,0,10.39-.17,17.1-.17A23.92,23.92,0,0,1,616,60.16c0,16.76-11.73,25.14-24.8,25.14Zm18.44-2c6-.67,14.41-4.7,14.41-22.79,0-15.25-5.7-22-15.42-22.8-1.67-.16-7-.16-8.71-.16h-2.68V83.45H584a57.31,57.31,0,0,0,10.56-.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    className: "cls-4",
    d: "M256.9,85.8h-5.7V36h5.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    className: "cls-4",
    d: "M365.16,36s9.72,25,16.09,40.89L397.17,36h6.7v49.6H398V40.05C391,57.82,380.07,86,380.07,86H378.4s-11.06-28.16-17.93-45.92V85.63h-2.18V36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    className: "cls-4",
    d: "M477.94,60.16c0,16.42-10.73,26.31-23.13,26.31s-23.46-10.72-23.46-24.8c0-17.09,12.24-26.65,23-26.65C466,35,477.94,44.58,477.94,60.16Zm-38.88.34c0,23.12,11.9,24,15.75,24,4.7,0,15.42-2.68,15.42-23.63s-10.39-24-15.25-24-15.92,1.67-15.92,23.63Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    className: "cls-4",
    d: "M512.13,36l28.49,39.38V36h2.18c0,5.53-.17,46.25,0,47.42v3.36h-1.68S509,42.57,508.78,42.57s0,43.23,0,43.23h-2.35V36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    className: "cls-4",
    d: "M668,43.4c.17.34,0,.5-.17.67s-1,.67-1.17,0c-3.35-5.7-7.71-7.2-14.08-7.2-5.53,0-9.38,3.85-9.38,8.38s3.68,7.2,7.87,8.54a111.54,111.54,0,0,1,11.4,3.86,14.19,14.19,0,0,1,8.88,13.57c0,8.21-7.71,14.58-19.61,14.41-7-.16-14.74-8.21-14.07-9.38.16-.34.16-.5.33-.5,1.68-.34,6.7,7.2,14.08,7.2,8.21,0,14.74-4.19,14.91-10.22.17-7.54-10.05-9.55-16.42-11.9-3.35-1.17-11.4-4-11.4-12.9,0-7.87,6.87-13.07,13.57-13.24C661.27,34.86,665.46,38.21,668,43.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    className: "cls-4",
    d: "M305.5,34.86h-4.86L282,85.13h3c2.35-6.7,13.58-37.37,16.26-44.74l15.42,44.74h6.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    className: "cls-5",
    d: "M75.91,135.4l72.57-75.91H1.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    className: "cls-4",
    d: "M76.08,136.41l-.5-.5L0,58.82H150ZM3.18,60.16,75.91,134.4,146.8,60.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    className: "cls-5",
    d: "M25.47,9.89l-23,27.65h145L124.68,9.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    className: "cls-4",
    d: "M149,38.38H1.17l24-29.16H125ZM4.19,37H146.3L124.51,10.56H25.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    className: "cls-5",
    d: "M76.08,119l57.48-66H18.6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    className: "cls-4",
    d: "M76.08,120l-.5-.5-58.32-67H135.07Zm-56-66.36,56,64.35,56.14-64.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    className: "cls-4",
    d: "M120.66,58,76.08,109.09h0V58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    className: "cls-5",
    d: "M39.38,17.76l-21,25.81H133.56L112.78,17.76Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    className: "cls-4",
    d: "M135.07,44.24h-118l5.37-6.7L39.05,17.09h74.07l.16.17ZM19.94,42.9H132.22L112.45,18.43H39.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-3",
    d: "M43.07,22.79,31,37.71H76.08V22.79Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-4",
    d: "M125,3.85a10.54,10.54,0,0,0,5.7,5.7,9.42,9.42,0,0,0-3.36,2.35A14.94,14.94,0,0,0,125,15.25a10.54,10.54,0,0,0-5.7-5.7,11.79,11.79,0,0,0,5.7-5.7M125,0a9.36,9.36,0,0,1-9.35,9.38h0a9.9,9.9,0,0,1,9.55,9.56,9.37,9.37,0,0,1,9.36-9.39h0A9.75,9.75,0,0,1,125,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-5",
    d: "M125,15.42a10.1,10.1,0,0,0-5.86-5.87A10.73,10.73,0,0,0,125,3.69a10.15,10.15,0,0,0,5.87,5.86A10.83,10.83,0,0,0,125,15.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10551",
    "data-name": "Rectangle 10551",
    className: "cls-6",
    x: 121.11,
    y: 5.66,
    width: 7.41,
    height: 8.19
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Supplier_Centre",
    "data-name": "Supplier Centre",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M779.41,69.31c-3.94-1.48-6.79-3.29-8.57-5.4a12,12,0,0,1-2.66-8,12.94,12.94,0,0,1,2-7.16,13.73,13.73,0,0,1,5.8-4.94,20.62,20.62,0,0,1,8.89-1.8,37.44,37.44,0,0,1,13.32,2.6v5.83a44.37,44.37,0,0,0-12.82-2.23q-4.68,0-7.23,1.9a6.39,6.39,0,0,0-2.56,5.44,6.11,6.11,0,0,0,1.73,4.57q1.73,1.69,6.41,3.42L790.28,66q5.84,2.16,8.39,5.22a11.9,11.9,0,0,1,2.55,7.88,13.6,13.6,0,0,1-4.93,11q-4.93,4.11-13.28,4.1a32.79,32.79,0,0,1-14.4-3V85.51A45.14,45.14,0,0,0,782.86,88q5.11,0,8-2.23a7.2,7.2,0,0,0,2.92-6,6.2,6.2,0,0,0-1.69-4.43A16.31,16.31,0,0,0,786.39,72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.21,93l-.79-3.89q-6.7,5-13.76,5-5.11,0-7.84-2.88t-2.74-8.14V56.5h7.13V80.76q0,3.88,1.51,5.72c1,1.23,2.61,1.84,4.82,1.84A18.86,18.86,0,0,0,834,84.86V56.5h7.13V93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M851.77,107.83V56.5h6l.65,3.74a18,18,0,0,1,12.17-4.82,13.33,13.33,0,0,1,11,5.07q4,5.09,4,13.79t-4.25,14.18a13.7,13.7,0,0,1-11.3,5.33,16,16,0,0,1-11.16-4.25v18.29Zm16.77-46.65a16,16,0,0,0-9.64,3.31V84.58A15.88,15.88,0,0,0,868.4,88q9.93,0,9.94-13.39,0-6.84-2.42-10.15C874.31,62.28,871.86,61.18,868.54,61.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M894.39,107.83V56.5h6l.65,3.74a17.91,17.91,0,0,1,12.16-4.82,13.32,13.32,0,0,1,11,5.07q4,5.09,4,13.79T924,88.46a13.7,13.7,0,0,1-11.3,5.33,16,16,0,0,1-11.16-4.25v18.29Zm16.78-46.65a16.05,16.05,0,0,0-9.65,3.31V84.58A15.9,15.9,0,0,0,911,88Q921,88,921,74.64q0-6.84-2.41-10.15T911.17,61.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M950.05,92.5a15.27,15.27,0,0,1-5.19.86,7.5,7.5,0,0,1-5.83-2.2,9,9,0,0,1-2-6.3V39.72h7.13V84.43a3.49,3.49,0,0,0,.69,2.41,2.89,2.89,0,0,0,2.26.76,20.15,20.15,0,0,0,3-.22Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M961.42,50a4.42,4.42,0,0,1-3.27-1.19,4.72,4.72,0,0,1,0-6.27,5.13,5.13,0,0,1,6.55,0,4.72,4.72,0,0,1,0,6.27A4.45,4.45,0,0,1,961.42,50Zm-3.6,43V56.5H965V93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M980.93,76.3q.15,6.18,3.06,9.14t9,3a32.61,32.61,0,0,0,11.59-2.23v5.11A26.31,26.31,0,0,1,992,94.08q-8.87,0-13.39-4.9T974,74.71q0-9.13,4.54-14.22t12.67-5.07q6.84,0,10.51,3.85t3.67,10.91a30.19,30.19,0,0,1-.57,6.12Zm9.94-15.48a9.18,9.18,0,0,0-7.06,2.7q-2.52,2.7-2.88,8h17.93a16.45,16.45,0,0,0,.07-1.87q0-4.38-2-6.62A7.75,7.75,0,0,0,990.87,60.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1014,93V56.5h6l.79,5.4a23.41,23.41,0,0,1,3.74-3.35,13.74,13.74,0,0,1,3.53-1.77,12.84,12.84,0,0,1,3.89-.57,22.59,22.59,0,0,1,2.95.21V62.9a32.44,32.44,0,0,0-3.89-.28,14.8,14.8,0,0,0-9.86,3.45V93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1095.55,91.63A34.83,34.83,0,0,1,1083,93.86q-11.82,0-17.9-6.51T1059,68.23q0-12.45,6.3-19.15t18-6.7a33.6,33.6,0,0,1,11.51,1.95v6a50,50,0,0,0-10.65-1.51q-9.08,0-13.25,4.43t-4.18,14.08V69q0,9.51,4.07,14t12.93,4.47a51.46,51.46,0,0,0,11.8-1.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1108.44,76.3q.15,6.18,3.06,9.14t9,3a32.61,32.61,0,0,0,11.59-2.23v5.11a26.33,26.33,0,0,1-12.67,2.81q-8.87,0-13.39-4.9t-4.54-14.47q0-9.13,4.54-14.22t12.67-5.07q6.84,0,10.51,3.85t3.67,10.91a30.19,30.19,0,0,1-.57,6.12Zm9.94-15.48a9.18,9.18,0,0,0-7.06,2.7q-2.52,2.7-2.88,8h17.93a16.45,16.45,0,0,0,.07-1.87q0-4.38-2-6.62A7.75,7.75,0,0,0,1118.38,60.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1166.19,93V68.59q0-3.81-1.55-5.61t-4.86-1.8a19.82,19.82,0,0,0-11.16,3.67V93h-7.13V56.5h6l.72,4a23.67,23.67,0,0,1,14.4-5.11q5.25,0,8,2.77c1.82,1.85,2.73,4.52,2.73,8V93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1204.35,92.14a22.08,22.08,0,0,1-8,1.36q-10.21,0-10.22-10.22V62.11h-6.62V57.5l6.84-.86,1.08-10.37h5.83V56.5h10.8v5.61h-10.8V82.92c0,1.78.39,3,1.19,3.74s2.14,1.08,4.06,1.08a24,24,0,0,0,5.84-.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1211.4,93V56.5h6l.79,5.4a23.41,23.41,0,0,1,3.74-3.35,13.9,13.9,0,0,1,3.53-1.77,12.84,12.84,0,0,1,3.89-.57,22.59,22.59,0,0,1,3,.21V62.9a32.44,32.44,0,0,0-3.89-.28,14.82,14.82,0,0,0-9.86,3.45V93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1242.58,76.3q.14,6.18,3.06,9.14t9,3a32.57,32.57,0,0,0,11.59-2.23v5.11a26.31,26.31,0,0,1-12.67,2.81q-8.85,0-13.39-4.9t-4.53-14.47q0-9.13,4.53-14.22t12.67-5.07q6.84,0,10.51,3.85t3.68,10.91a30.15,30.15,0,0,1-.58,6.12Zm9.93-15.48a9.17,9.17,0,0,0-7,2.7q-2.52,2.7-2.88,8h17.92a15.86,15.86,0,0,0,.08-1.87c0-2.92-.69-5.13-2-6.62A7.78,7.78,0,0,0,1252.51,60.82Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "cls-7",
    x1: 718.72,
    y1: 1.67,
    x2: 718.72,
    y2: 131.74
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bee7e3fddb6faaaa461009ea2ca4fb4a.svg";
export { ForwardRef as ReactComponent };